import React from 'react';
import './CompanyStrategy.css';

function BusinessContinuityPlan() {
  return (
    <div className="document-section">
      <h2>Business Continuity Plan</h2>
      <iframe
        src="/pdfs/nesim-business-continuity-plan-final.pdf"
        title="Business Continuity Plan"
        width="100%"
        height="800px"
        style={{ border: 'none' }}
      ></iframe>
    </div>
  );
}

export default BusinessContinuityPlan;
